import dayjs from 'dayjs';
import { MessageBox, Message } from 'element-ui';
import { searchFieldSeperated } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/searcher.js';
/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
export const formatSearchData = data => {
    data.arrivalTimeStart = data.arrivalTime ? dayjs(data.arrivalTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    data.arrivalTimeEnd = data.arrivalTime ? dayjs(data.arrivalTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    data.departStartTime = data.actDepartTime ? dayjs(data.actDepartTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    data.departEndTime = data.actDepartTime ? dayjs(data.actDepartTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    data.customerOrderNoList = searchFieldSeperated(data.customerOrderNo);
    data.siteCodeList = data.siteCode ? data.siteCode.split(',') : [];
    data.siteNameList = data.siteName ? data.siteName.split(',') : [];
    delete data.endTime;
    delete data.startTime;
    delete data.arrivalTime;
    delete data.actDepartTime;
    delete data.customerOrderNo;
    delete data.siteCode;
    delete data.siteName;
    return data;
};
/**
 * @description 校验查询参数
 */
export const validateSearchData = (data, accountSign) => {
    const isExitCustomerOrderNo = data.customerOrderNoList && data.customerOrderNoList.length;
    if ((!data.departStartTime || !data.departEndTime) && !isExitCustomerOrderNo && !data.dispatchNo){
        Message.warning('客户订单号、发车单号、发车时间不能同时为空');
        return false;
    }
    if (data.customerOrderNoList.length && data.customerOrderNoList.length > 100) {
        Message.warning(`按照单号查询，每次最多支持查询100单`);
        return false;
    }
    if (data.departStartTime && data.departEndTime) {
        const sDateTimeStamp = new Date(data.departStartTime).getTime();
        const eDateTimeStamp = new Date(data.departEndTime).getTime();
        const maxDay63 = 1000 * 60 * 60 * 24 * 63;
        if (eDateTimeStamp - sDateTimeStamp > maxDay63) {
            Message.warning('按时间查询或导出时，查询或导出时间跨度不可超过两个月');
            return false;
        }
    }
    if (+accountSign === 1) {
        if (!(data.hasOwnProperty('stationName') && data.stationName)) {
            Message.warning('货站名称查询条件不能为空');
            return false;
        }
    }
    return true;
};

/**
 * @description 按钮显隐
 * @assignDriverFlag 是否可以指派末端司机（0-可以/1-不可以）
 * @withdrawFlag 是否可以撤回（0-可以/1-不可以）
 * @transportFlag 是否可以转单（0-可以/1-不可以）
 * @lspTransferStationName 【货站运抵】操作按钮展示逻辑：只有货站不为空时才展示
 */
export const dealWithBtnShow = data => {
    const { assignDriverFlag, withdrawFlag, transportFlag, stationName } = data;
    let hiddenEvent = [];
    if (assignDriverFlag === '1' ) {
        hiddenEvent.push('assignDriver')
    }
    if (withdrawFlag === '1' ) {
        hiddenEvent.push('withdraw')
    }
    if (transportFlag === '1' ) {
        hiddenEvent.push('transferOrder')
    }
    if (!stationName) {
        hiddenEvent.push('arrivalConfirmation')
    }
    return hiddenEvent;
}

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {Function} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 需要传递的参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 */
export const messageTips = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            that.getList();
                            done();
                        }
                    })
                    .catch(() => { })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                    });
            } else {
                done();
            }
        }
    }).catch(()=>{}); // 添加错误捕获
};
